import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "contact-section bg-black",
  id: "contact"
}
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = { class: "row gx-4 gx-lg-5" }
const _hoisted_4 = { class: "col-md-4 mb-3 mb-md-0" }
const _hoisted_5 = { class: "card py-4 h-100" }
const _hoisted_6 = { class: "card-body text-center" }
const _hoisted_7 = { class: "col-md-4 mb-3 mb-md-0" }
const _hoisted_8 = { class: "card py-4 h-100" }
const _hoisted_9 = { class: "card-body text-center" }
const _hoisted_10 = { class: "small" }
const _hoisted_11 = { class: "col-md-4 mb-3 mb-md-0" }
const _hoisted_12 = { class: "card py-4 h-100" }
const _hoisted_13 = { class: "card-body text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-location-dot",
                class: "text-primary mb-2"
              }),
              _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "text-lowercase m-0" }, "address", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "my-4 mx-auto" }, null, -1)),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "small text-black-50" }, " Entenmarkt 12, 53902 Bad Münstereifel, Germany ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-envelope",
                class: "text-primary mb-2"
              }),
              _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-lowercase em-0" }, "email", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "my-4 mx-auto" }, null, -1)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_LinkComponent, {
                  href: "mailto:info@ironwood-flutes.com",
                  "link-text": "info@ironwood-flutes.com",
                  class: "text-black-50"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-phone",
                class: "text-primary mb-2"
              }),
              _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "text-lowercase m-0" }, "phone", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "my-4 mx-auto" }, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "small text-black-50" }, "+49 2253 5448451", -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}